import Region from '@app/model/market_state/Region';

export const PaletteColors = [
	'#fb2c36', '#ff6900', '#fe9a00', '#f0b100',
	'#7ccf00', '#00c950', '#00bc7d', '#00bba7',
	'#00b8db', '#00a6f4', '#2b7fff', '#615fff',
	'#8e51ff', '#ad46ff', '#e12afb', '#f6339a',
];

export const RegionColors: Map<Region, string> = new Map([
	[Region.ALBANIA, PaletteColors[0]],        // Red
	[Region.EUROPE, PaletteColors[9]],         // Blue
	[Region.UNITED_STATES, PaletteColors[10]], // Blue
	[Region.UNITED_KINGDOM, PaletteColors[0]], // Red
	[Region.GERMANY, PaletteColors[3]],        // Yellow
	[Region.BULGARIA, PaletteColors[5]],      // Green
	[Region.ITALY, PaletteColors[6]],          // Green
	[Region.FRANCE, PaletteColors[8]],         // Blue
	[Region.NETHERLANDS, PaletteColors[1]],    // Orange
	[Region.POLAND, PaletteColors[15]],        // Red/Pink
	[Region.ROMANIA, PaletteColors[2]],        // Yellow/Orange
	[Region.SERBIA, PaletteColors[11]],        // Indigo/Blue
	[Region.SWITZERLAND, PaletteColors[14]],   // Pink/Red
	[Region.AUSTRIA, PaletteColors[13]],       // Purple/Red
	[Region.ISRAEL, PaletteColors[12]],        // Purple/Blue
	[Region.CZECH_REPUBLIC, PaletteColors[0]], // Light Green
	[Region.CANADA, PaletteColors[13]], // Light Green
	[Region.AUSTRALIA, PaletteColors[3]], // Light Green
	[Region.SINGAPORE, PaletteColors[14]], // Light Green
	[Region.TURKEY, PaletteColors[15]], // Light Green
]);